import { Fragment } from 'react'
import styles from '../../AdventureCardDsl.module.scss'
import {
  ActivityDives,
  ActivityDuration,
  CourseInclusions,
  ElearningDuration,
} from '../AdventureCardInclusions'
import AvailableDates from '../../../adventures/AvailableDate'

const CourseInfo = ({ adventure, infoType, isOtherActivity }) => {
  return (
    <Fragment>
      <strong className={styles.title}>{adventure.title}</strong>
      <ActivityDuration item={adventure} />
      <div className={styles.inclusion}>
        <i className='dsl-icons dsl-icons--calendar' />
        <AvailableDates date={adventure.availableDate} infoType={infoType} />
      </div>
      {isOtherActivity ? (
        <ActivityDives item={adventure} />
      ) : (
        <CourseInclusions infoType={infoType} item={adventure} />
      )}
    </Fragment>
  )
}

const ElearningInfo = ({ adventure }) => {
  return (
    <Fragment>
      <strong className={styles.title}>{adventure.title}</strong>
      <ElearningDuration item={adventure} />
      <div className={styles.inclusion}>
        <i className='dsl-icons dsl-icons--calendar' />
        <AvailableDates date={adventure.availableDate} infoType='elearning' />
      </div>
      <CourseInclusions infoType='elearning' item={adventure} />
    </Fragment>
  )
}

export { CourseInfo, ElearningInfo }
